import { render } from "./brightness.vue?vue&type=template&id=a9adf752&scoped=true"
import script from "./brightness.vue?vue&type=script&lang=js"
export * from "./brightness.vue?vue&type=script&lang=js"

import "./brightness.vue?vue&type=style&index=0&id=a9adf752&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9adf752"]])

export default __exports__